import { render, staticRenderFns } from "./sharingDetails.vue?vue&type=template&id=a6199568&"
import script from "./sharingDetails.vue?vue&type=script&lang=js&"
export * from "./sharingDetails.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports